import { useQuery } from 'urql';

import { NewOfferExpensesDocument } from '~src/graphql';
import { NewOfferExpenses } from '~src/model';

export const useFetchNewOfferExpenses = () => {
  const [result] = useQuery({ query: NewOfferExpensesDocument, requestPolicy: 'cache-first' });

  return result?.data?.newOfferExpenses as NewOfferExpenses;
};
